import React from 'react'
import { StyledButton } from './styles'

const Button = React.memo(({ children, style = {}, disabled, ...props }) => {
    return (
        <StyledButton style={style} disabled={disabled} {...props}>
            {children}
        </StyledButton>
    )
})

export default Button
